import React from "react";
import { Dialog } from "primereact/dialog";
import { Label, Col, Row, Container } from "reactstrap";
import { Fieldset } from "primereact/fieldset";
import moment from "moment";
import { BillTariffModel, ScaleTier } from "../../models/BillTariff";
import { renderDualRow } from "../../Pages/Users/TransactionDetails";
import { DEFAULT_CURRENCY } from "../../models/AppConstants";
import BillTariffVersionsList from "./BillTariffVersionsList";

interface ViewBillTariffModalProps {
    visible: boolean;
    billTariff: BillTariffModel | null;
    onHide: () => void;
}

const ViewBillTariffModal: React.FC<ViewBillTariffModalProps> = ({ visible, billTariff, onHide }) => {

    if (!billTariff) {
        return null;
    }

    const isScale = billTariff.tariffType === "SCALE";
    let scaleTiers: ScaleTier[] = [];

    if (isScale) {
        try {
            scaleTiers = JSON.parse(billTariff.value) as ScaleTier[];
        } catch {
            // If parsing fails, scaleTiers remains empty array
        }
    }

    return (
        <Dialog
            header="View Bill Tariff"
            visible={visible}
            style={{ width: "70vw" }}
            baseZIndex={1000}
            onHide={onHide}
            closable={true}
            closeOnEscape={true}
        >
            <div style={{ maxHeight: "70vh", overflowY: "auto", padding: "10px" }}>
                <Container fluid>
                    <Fieldset legend="Bill Tariff Summary" collapsed={true}>
                        {renderDualRow(
                            "Bill Type Code",
                            billTariff.billTypeCode,
                            false,
                            () => {},
                            "Tariff Type",
                            billTariff.tariffType,
                            false,
                            () => {},
                        )}
                        {renderDualRow(
                            "Version",
                            billTariff.version.toString(),
                            false,
                            () => {},
                            "Status",
                            billTariff.status ? "Active" : "Inactive",
                            false,
                            () => {},
                        )}
                        {!isScale && renderDualRow(
                            "Currency",
                            billTariff.currency || DEFAULT_CURRENCY,
                            false,
                            () => {},
                            "Value",
                            billTariff.value,
                            false,
                            () => {},
                        )}
                        {isScale && renderDualRow(
                            "Currency",
                            billTariff.currency || DEFAULT_CURRENCY,
                            false,
                            () => {},
                            null,
                            "",
                            false,
                            () => {},
                        )}
                        {renderDualRow(
                            "Effective From",
                            billTariff.effectiveFrom 
                                ? moment(billTariff.effectiveFrom).format("DD/MM/YYYY")
                                : "-",
                            false,
                            () => {},
                            "Effective To",
                            billTariff.effectiveTo 
                                ? moment(billTariff.effectiveTo).format("DD/MM/YYYY")
                                : "-",
                            false,
                            () => {},
                        )}
                        {renderDualRow(
                            "Created On",
                            billTariff.createdTimeStamp 
                                ? moment(billTariff.createdTimeStamp).format("DD/MM/YYYY HH:mm")
                                : "-",
                            false,
                            () => {},
                            "Modified On",
                            billTariff.modifiedTimeStamp 
                                ? moment(billTariff.modifiedTimeStamp).format("DD/MM/YYYY HH:mm")
                                : "-",
                            false,
                            () => {},
                        )}
                    </Fieldset>

                    {isScale && scaleTiers.length > 0 && (
                        <>
                            <h5></h5>
                            <Fieldset legend="Scale Tiers" toggleable={true} collapsed={false}>
                                <div style={{ 
                                    border: "1px solid #dee2e6", 
                                    borderRadius: "4px", 
                                    padding: "1rem",
                                    marginTop: "0.5rem"
                                }}>
                                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                        <thead>
                                            <tr style={{ borderBottom: "1px solid #dee2e6" }}>
                                                <th style={{ padding: "0.5rem", textAlign: "left", borderBottom: "1px solid #dee2e6" }}>#</th>
                                                <th style={{ padding: "0.5rem", textAlign: "left", borderBottom: "1px solid #dee2e6" }}>Min Amount</th>
                                                <th style={{ padding: "0.5rem", textAlign: "left", borderBottom: "1px solid #dee2e6" }}>Max Amount</th>
                                                <th style={{ padding: "0.5rem", textAlign: "left", borderBottom: "1px solid #dee2e6" }}>Rate (%)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {scaleTiers.map((tier, index) => (
                                                <tr key={index} style={{ borderBottom: "1px solid #dee2e6" }}>
                                                    <td style={{ padding: "0.5rem" }}>{index + 1}</td>
                                                    <td style={{ padding: "0.5rem" }}>{tier.minValue}</td>
                                                    <td style={{ padding: "0.5rem" }}>{tier.maxValue === 0 ? "∞" : tier.maxValue}</td>
                                                    <td style={{ padding: "0.5rem" }}>{tier.tariffAmount}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </Fieldset>
                        </>
                    )}

                    <BillTariffVersionsList 
                        billTypeCode={billTariff.billTypeCode}
                        currentTariffId={billTariff.id}
                        visible={visible}
                    />
                </Container>
            </div>
        </Dialog>
    );
};

export default ViewBillTariffModal;

